module.exports = __webpack_public_path__ + "static/media/team_icon.aa9acd8d.svg";